function initProductSwiper(el) {
  if (el.swiper || el.dataset.swiperInitialized) return;

  el.dataset.swiperInitialized = "true";

  const nextBtn = el.querySelector(".swiper-button-next");
  const prevBtn = el.querySelector(".swiper-button-prev");
  const paginationEl = el.querySelector(".swiper-pagination");

  new Swiper(el, {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 10,

    preloadImages: false,

    lazy: {
      loadPrevNext: true,
    },

    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },

    pagination: paginationEl
      ? {
          el: paginationEl,
          clickable: true,
        }
      : false,
  });
}

function initVisibleSwipers(scope = document) {
  const swipers = scope.querySelectorAll(".card-product-media-swiper");

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        initProductSwiper(entry.target);

        obs.unobserve(entry.target);
      });
    },
    {
      rootMargin: "200px",
    },
  );

  swipers.forEach((swiper) => {
    observer.observe(swiper);
  });
}

window.addEventListener("load", () => {
  initVisibleSwipers();
});

document.addEventListener("facet:rendered", () => {
  initVisibleSwipers(document);
});
